import types from './types';
import globalTypes from '../types';

const InitialState = {
    loaded: false,
    user: null,
    logins: null,
    pending_voucher: null,
    deposit_bonus: null,
    facebook_profile: null,
    welcome_bonus: null,
    kyc_profile: {
        status: "unverified"
    },
    facebook: {
        profile: null,
        button: false
    }
}

export default (state = InitialState, {type, payload}) => {
    switch(type) {
        case types.deposit_bonus:
            return {
                ...state,
                deposit_bonus: payload ? {
                    ...payload,
                    details: {
                        ...payload.details,
                        expire_at: payload.details.expire_at + Date.now()
                    }
                } : null
            }
        case types.kyc_profile.verification:
            return {
                ...state,
                kyc_profile: {
                    ...state.kyc_profile,
                    verification: payload
                }
            }
        case types.welcome_bonus:
            return {
                ...state,
                welcome_bonus: payload
            }
        // EMAIL CONFIRMATION
        case globalTypes.modals.email_confirmation.update_user:
            return {
                ...state,
                user: {
                    ...state.user,
                    email: {
                        ...state.user.email,
                        ...payload,
                        timestamp: payload.timestamp ? payload.timestamp + Date.now() : state.user.email.timestamp
                    }
                }
            }
        case globalTypes.modals.phone_confirmation.update_user:
            return {
                ...state,
                user: {
                    ...state.user,
                    phone: {
                        ...state.user.phone,
                        ...payload,
                        timestamp: payload.timestamp ? payload.timestamp + Date.now() : state.user.phone.timestamp
                    }
                }
            }
        case types.promotions.modals.clear:
            return {
                ...state,
                modals_list: []
            }
        case types.promotions.modals.remove:
            return {
                ...state,
                modals_list: state.modals_list.filter(r => r !== payload)
            }
        case types.facebook.toggle:
            return {
                ...state,
                facebook: {
                    ...state.facebook,
                    button: !state.facebook.button
                }
            }
        case types.facebook.update:
            return {
                ...state,
                facebook: {
                    profile: {
                        ...payload,
                        active_bonus_time: payload.facebook.active_bonus_time > 0 ? (payload.facebook.active_bonus_time + Date.now()) : 0
                    },
                    button: false
                }
            }
        case types.update:
            return {
                ...state,
                user: {
                    ...state.user,
                    ...payload
                }
            }
        case types.logout:
            return {
                ...state,
                user: null,
                logins: [],
                pending_voucher: null
            }
        case types.pending_voucher:
            return {
                ...state,
                pending_voucher: payload
            }
        case types.vip.xp:
            return {
                ...state,
                user: state.user ? {
                    ...state.user,
                    xp: payload
                } : state.user
            }
        case types.game:
            return {
                ...state,
                user: state.user ? {
                    ...state.user,
                    game: payload
                } : state.user
            }
        case types.balance:
            return {
                ...state,
                user: state.user ? {
                    ...state.user,
                    balance: payload.balance,
                    wager: payload.wager,
                    diamonds: payload.diamonds
                } : state.user
            }
        case types.logins.create:
            return {
                ...state,
                logins: state.logins ? [
                    {
                        ...payload,
                        balance_details: {
                            ...payload.balance_details,
                            lastUpdateTimestamp: payload.balance_details.lastUpdateTimestamp + Date.now()
                        }
                    },
                    ...state.logins
                ] : state.logins
            }
        case types.logins.remove:
            return {
                ...state,
                logins: state.logins ? state.logins.filter(login => login.game !== payload) : state.logins
            }
        case types.logins.update:
            return {
                ...state,
                logins: state.logins ? state.logins.map(login => {
                    return login.id === payload.id ? {
                        ...login,
                        ...payload,
                        balance_details: payload.balance_details ? {
                            ...payload.balance_details,
                            lastUpdateTimestamp: payload.balance_details.lastUpdateTimestamp + Date.now()
                        } : login.balance_details
                    } : login;
                }) : state.logins
            }
        case types.game:
            return {
                ...state,
                user: state.user ? {
                    ...state.user,
                    game: payload
                } : state.user
            }
        case types.loaded:
            return {
                ...state,
                loaded: true,
                user: payload.user ? {
                    ...payload.user,
                    email: {
                        ...payload.user.email,
                        timestamp: payload.user.email.timestamp ? payload.user.email.timestamp + Date.now() : 0
                    },
                    phone: {
                        ...payload.user.phone,
                        timestamp: payload.user.phone.timestamp ? payload.user.phone.timestamp + Date.now() : 0
                    }
                } : payload.user,
                pending_voucher: payload.pending_voucher,
                deposit_bonus: payload.deposit_bonus ? {
                    ...payload.deposit_bonus,
                    details: {
                        ...payload.deposit_bonus.details,
                        expire_at: payload.deposit_bonus.details.expire_at + Date.now()
                    }
                } : state.deposit_bonus,
                logins: payload.logins.map(login => {
                    return {
                        ...login,
                        balance_details: {
                            ...login.balance_details,
                            lastUpdateTimestamp: login.balance_details.lastUpdateTimestamp + Date.now()
                        }
                    }
                }),
                facebook: payload.facebook ? {
                    profile: {
                        ...payload.facebook,
                        active_bonus_time: payload.facebook.active_bonus_time > 0 ? (payload.facebook.active_bonus_time + Date.now()) : 0
                    },
                    button: false
                } : {
                    profile: null,
                    button: false
                },
                modals_list: payload.modals_list,
                welcome_bonus: payload.welcome_bonus,
                kyc_profile: payload.kyc_profile
            }
        default:
            return state;
    }
}